(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/possibleConstructorReturn', 'babel-runtime/helpers/inherits', 'react', '@material-ui/core/Dialog', '@material-ui/core/DialogContent', '@material-ui/core/DialogActions', './ModalHeader'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('react'), require('@material-ui/core/Dialog'), require('@material-ui/core/DialogContent'), require('@material-ui/core/DialogActions'), require('./ModalHeader'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.classCallCheck, global.possibleConstructorReturn, global.inherits, global.react, global.Dialog, global.DialogContent, global.DialogActions, global.ModalHeader);
    global.Modal = mod.exports;
  }
})(this, function (exports, _classCallCheck2, _possibleConstructorReturn2, _inherits2, _react, _Dialog, _DialogContent, _DialogActions, _ModalHeader) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

  var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

  var _inherits3 = _interopRequireDefault(_inherits2);

  var React = _interopRequireWildcard(_react);

  var _Dialog2 = _interopRequireDefault(_Dialog);

  var _DialogContent2 = _interopRequireDefault(_DialogContent);

  var _DialogActions2 = _interopRequireDefault(_DialogActions);

  var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Modal = function (_React$Component) {
    (0, _inherits3.default)(Modal, _React$Component);

    function Modal() {
      (0, _classCallCheck3.default)(this, Modal);
      return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
    }

    Modal.prototype.render = function render() {
      var _props = this.props,
          width = _props.width,
          close = _props.close,
          children = _props.children;


      return React.createElement(
        _Dialog2.default,
        {
          open: true,
          maxWidth: width,
          fullWidth: true,
          onBackdropClick: close,
          'data-testid': 'modal'
        },
        children
      );
    };

    return Modal;
  }(React.Component);

  Modal.Header = _ModalHeader2.default;
  Modal.Body = _DialogContent2.default;
  Modal.Footer = _DialogActions2.default;
  Modal.defaultProps = { width: false };
  exports.default = Modal;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Modal/Modal.js
// module id = 1996
// module chunks = 1